import { useSearchParams } from 'react-router';
import { EmptyState } from '@indipia/ui-core';
import { CustomerHomePage } from './CustomerHomePage';

/**
 * 고객대시보드 발송자 미리보기 — /customer-home/preview?shareId={발송 이력 수신자 행의 shareId}.
 * 로그인(RequireAuth) 안쪽 라우트라 로그인 토큰으로 조회하며, 고객 방문 기록·열람 알림이 남지 않는다.
 * 발송 이력 화면(photo-organizer 발송 이력)의 고객 수신 건 "미리보기"가 이 경로를 연다.
 */
export function CustomerHomePreviewPage() {
  const [params] = useSearchParams();
  const raw = params.get('shareId');
  const shareId = raw !== null && /^\d+$/.test(raw) ? Number(raw) : null;
  const rawHistory = params.get('historyId');
  const historyId = rawHistory !== null && /^\d+$/.test(rawHistory) ? Number(rawHistory) : undefined;
  if (shareId === null) {
    return (
      <div className="mx-auto flex min-h-screen w-full max-w-md flex-col justify-center bg-surface p-05">
        <EmptyState title="미리보기를 열 수 없습니다" description="발송 이력에서 미리보기를 다시 눌러 주세요." />
      </div>
    );
  }
  return <CustomerHomePage previewShareId={shareId} previewHistoryId={historyId} />;
}
